import classNames from "classnames";

/**
 * Section layout keys. These are the keys that come back from Polopoly, the are used at both the Section Container level for css class names, and at the ContentGrid level for grid layouts.
 */

export const DEFAULT_KEY = "default";
export const DEFAULT_LIGHT_KEY = "default-light";
export const DEFAULT_DARK_KEY = "default-dark";
export const OLYMPICS_LIGHT_KEY = "olympicslight";
export const OLYMPICS_DARK_KEY = "olympicsdark";
export const DEFAULT_CONDENSED_KEY = "default-condensed";
export const FEATURED_KEY = "featured";
export const FEATURED_VERTICALRIGHTCOL_KEY =
    "featured_verticalRightCol_noLimit";
export const VERTICAL_LIST_MAIN = "verticallisting";
export const FEATURED_DESCRIPTION = "featured-description";
export const FEATURED_CONDENSED_KEY = "featured-condensed";
export const DEFAULT_SHOWS_KEY = "default-shows";
export const DESCRIPTION = "DESCRIPTION";
/**
 * Section layout mapping to class names.
 */
const BACKGROUND_COLOR_CLASS_NAME = "oc-l-sectionContainer-backgroundColor";
const SIDESCROLL_CLASS_NAME = "oc-l-sectionContainer-sideScroll";

export const SECTION_LAYOUT_CLASS_NAMES = new Map([
    [
        DEFAULT_LIGHT_KEY,
        classNames("oc-l-sectionContainer-light", BACKGROUND_COLOR_CLASS_NAME),
    ],
    [
        DEFAULT_DARK_KEY,
        classNames("oc-l-sectionContainer-dark", BACKGROUND_COLOR_CLASS_NAME),
    ],
    [
        OLYMPICS_LIGHT_KEY,
        classNames(
            "oc-l-sectionContainer-olympicsLight",
            "oc-l-sectionContainer-light",
            SIDESCROLL_CLASS_NAME,
            BACKGROUND_COLOR_CLASS_NAME
        ),
    ],
    [
        OLYMPICS_DARK_KEY,
        classNames(
            "oc-l-sectionContainer-olympicsDark",
            "oc-l-sectionContainer-dark",
            SIDESCROLL_CLASS_NAME,
            BACKGROUND_COLOR_CLASS_NAME
        ),
    ],
    [VERTICAL_LIST_MAIN, classNames("oc-l-sectionContainer-verticallistMain")],
]);

export const WITH_RIGHT_RAIL_CLASS_NAME = "oc-l-sectionContainer-withRightRail";
